// extracted by mini-css-extract-plugin
module.exports = {"container-main":"Main_container-main__3E2Ud","line-break":"Main_line-break__MROMw"};